import React from 'react';
import { Input, Label } from 'semantic-ui-react';

const validate = function(type, value) {
  switch (type) {
    case 'int':
      return value.match(/^-?\d+$/);
    case 'id':
      return value.length >=4 && value.length <= 64;
    case 'script':
      return value.length >= 1;
    case 'dice':
      return value.match(/^(\d+d\d+([+-]\d+)?|-?\d+)$/);
    default:
  }

  return true;
}

const InputField = function(props) {

  const placeholder = props.placeholder;
  const value = props.value;
  const type = props.type;
  const optional = props.optional;
  const onChange = (e,d) => {
    props.onChange(d.value);
    if (props.onValid) {
      props.onValid((d.value.length === 0 && optional) || validate(type, d.value));
    }
  }
  const label = props.label || ''
  const valid = (value.length === 0 && optional) || validate(type, value);

  return (
      <React.Fragment>
        <Label>{label}</Label>
        <Input error={!valid}
               placeholder={placeholder}
               value={value}
               fluid={props.fluid}
               autoFocus={props.autoFocus}
               onChange={onChange} />
      </React.Fragment>
  )
}


export default InputField;
